var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f8f8f8"},attrs:{"id":"app"}},[_c('test-environment-banner'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }